var _line, _line2, _line3, _line4, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHorizontalLineWIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 550,
    height: 50,
    viewBox: "0 0 550 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    y1: 18.5,
    x2: 250,
    y2: 18.5,
    stroke: "white",
    strokeWidth: 3
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 10,
    y1: 29.5,
    x2: 250,
    y2: 29.5,
    stroke: "white"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    y1: -0.5,
    x2: 240,
    y2: -0.5,
    transform: "matrix(-1 0 0 1 540 30)",
    stroke: "white"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    y1: -1.5,
    x2: 250,
    y2: -1.5,
    transform: "matrix(-1 0 0 1 550 20)",
    stroke: "white",
    strokeWidth: 3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M288.945 22.7578C289.59 23.2266 290 23.9297 290 24.75C290 25.5117 289.59 26.2734 288.945 26.7422L285.43 29.0859L286.25 33.2461C286.367 34.0078 286.133 34.8281 285.605 35.3555C285.02 35.9414 284.258 36.1758 283.438 36L279.277 35.2383L276.934 38.7539C276.523 39.3984 275.762 39.75 275 39.75C274.18 39.75 273.477 39.3984 273.008 38.7539L270.664 35.2383L266.504 36C265.684 36.1758 264.922 35.9414 264.395 35.3555C263.809 34.8281 263.574 34.0078 263.691 33.2461L264.512 29.0859L260.996 26.6836C260.352 26.2734 260 25.5117 260 24.75C260 23.9297 260.352 23.2266 260.996 22.7578L264.512 20.4141L263.691 16.2539C263.574 15.4922 263.809 14.6719 264.395 14.1445C264.922 13.5586 265.742 13.3242 266.504 13.4414L270.664 14.2617L273.008 10.7461C273.887 9.45703 276.055 9.45703 276.934 10.7461L279.277 14.2617L283.438 13.4414C284.199 13.3242 285.02 13.5586 285.605 14.0859C286.133 14.6719 286.367 15.4922 286.25 16.2539L285.43 20.4141L288.945 22.7578ZM282.324 27.7969L286.836 24.75L282.324 21.7031L283.32 16.3711L277.988 17.3672L275 12.8555L271.953 17.3672L266.621 16.3711L267.617 21.7031L263.164 24.75L267.617 27.7969L266.621 33.1289L271.953 32.0742L275 36.5859L277.988 32.1328L283.32 33.1289L282.324 27.7969ZM275 18.6562C278.34 18.6562 281.094 21.4102 281.094 24.75C281.094 28.1484 278.34 30.8438 275 30.8438C271.602 30.8438 268.906 28.1484 268.906 24.75C268.906 21.4102 271.602 18.6562 275 18.6562ZM275 28.0312C276.758 28.0312 278.281 26.5664 278.281 24.75C278.281 22.9922 276.758 21.4688 275 21.4688C273.184 21.4688 271.719 22.9922 271.719 24.75C271.719 26.5664 273.184 28.0312 275 28.0312Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHorizontalLineWIcon);
export default __webpack_public_path__ + "static/media/horizontalLineWIcon.b61c77e3c5535a914329879effbfcb03.svg";
export { ForwardRef as ReactComponent };